import { Icons as e } from "../Icons/Icons.mjs";
import { useVerifiedIdentityLabel as t } from "./hooks/useVerifiedIdentityLabel.mjs";
import { TruncatingBadge as n, TruncatingLabel as r } from "./VerifiedIdentityBadge.styled.mjs";
import "react";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/VerifiedIdentityBadge/VerifiedIdentityBadge.tsx
var a = ({ verified: a, countryCode: o, documentType: s, verifiedAt: c, size: l = "md", className: u }) => {
	let d = t({
		verified: a,
		countryCode: o,
		documentType: s,
		verifiedAt: c
	});
	return /* @__PURE__ */ i(n, {
		variant: a ? "success" : "secondary",
		size: l,
		icon: a ? e.ShieldCheck : e.ShieldAlert,
		className: u,
		children: /* @__PURE__ */ i(r, {
			title: d,
			children: d
		})
	});
};
//#endregion
export { a as VerifiedIdentityBadge };
